import React, { useEffect } from "react";
import Footer from "../components/Footer";
import Banner from "../components/home/Banner";
import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, Grid, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import InputStyle from "../assets/InputStyle";
import { useState, useRef } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddIcon from '@mui/icons-material/Add';
import flagIcon from "../images/flagIcon.png";
import regex from "../utils/regex";
import Navbar from "../components/Navbar";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { createProfile, uploadImages } from "../actions/userAuth";
import NumberInput from "../utils/NumberInput";
import { useSelector } from "react-redux";
import Layout from "../assets/Layout";
import { State, City, Country } from 'country-state-city';

const Profile = ({ }) => {
    const editor = useRef(null);
    const { user } = useSelector((state) => ({ ...state }));
    const [logoFile, setLogoFile] = useState([]);
    const [shortName, setShortName] = useState('');
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [directOfficeNumber, setDirectOfficeNumber] = useState('');
    const [officeNumber, setOfficeNumber] = useState('');
    const [website, setWebsite] = useState('');
    const [establishedYear, setEstablishedYear] = useState('');
    const [teamSize, setTeamSize] = useState('');
    const [industry, setIndustry] = useState('');
    const [type, setType] = useState('');
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [address, setAddress] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [taxIdentificationNumber, setTaxIdentificationNumber] = useState('');
    const [gstFile, setGstFile] = useState(null);
    const [taxFile, setTaxFile] = useState(null);
    const [pictures, setPictures] = useState([]);
    const [linkedin, setLinkedin] = useState('');
    const [twitter, setTwitter] = useState('');
    const [instagram, setInstagram] = useState('');
    const [facebook, setFacebook] = useState('');
    const [whatsApp, setWhatsApp] = useState('');
    const [youtube, setYoutube] = useState('');
    const [value, setValue] = useState('');
    const [mobileError, setMobileError] = useState(true);
    const [gstError, setGstError] = useState(true);
    const [emailError, setEmailError] = useState(true);
    const [loading, setLoading] = useState(false);
    const [countryCode, setCountryCode] = useState([]);
    const [allCountryList, setAllCountryList] = useState([]);
    const [allStates, setAllStates] = useState([]);
    const [allCities, setAllCities] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        setAllCountryList(Country.getAllCountries())
    }, [])

    const handleChangeCountry = (e) => {
        setCountry(Country.getCountryByCode(e.target.value))
        setAllStates(State.getStatesOfCountry(e.target.value))
    }


    const handleChangeState = (e) => {
        setAllCities(City.getCitiesOfState(country.isoCode, e.target.value));
        setState(State.getStateByCodeAndCountry(e.target.value, country.isoCode).name);
    };

    const handleChangeCity = (e) => {
        setCity(e.target.value);
    };


    // Get the current year
    const currentYear = new Date().getFullYear();

    // Generate an array of the last 30 years
    const last30Years = Array.from({ length: 30 }, (_, index) => currentYear - index);

    React.useEffect(() => {
        // setLogoFile(user?.avatar)
        setFullName(user?.name);
        setShortName(user?.shortNameOfCompany);
        setEmail(user?.email)
        setMobileNumber(user?.phone?.slice(-10));
        setCountryCode(user?.phone?.slice(0, -10));

        setWebsite(user?.website)
        setTeamSize(user?.teamSize)
        setDirectOfficeNumber(user?.directOfficeNumber?.slice(-10))
        setOfficeNumber(user?.phone?.slice(-10))
        setWebsite(user?.website)
        setEstablishedYear(user?.establishedIn)
        setIndustry(user?.industry)
        setType(user?.ownershipType)
        setCountry(user?.country)
        setState(user?.state)
        setCity(user?.city)
        setPinCode(user?.pinCode)
        setAddress(user?.address)
        setGstNumber(user?.GST_Number)
        setTaxIdentificationNumber(user?.taxIdentificationNumber)
        setTaxFile(user?.taxFile)
        setLinkedin(user?.socialNetworks?.linkedIn)
        setTwitter(user?.socialNetworks?.twitter)
        setInstagram(user?.socialNetworks?.Instagram)
        setFacebook(user?.socialNetworks?.facebook)
        setWhatsApp(user?.socialNetworks?.whatsApp)
        setYoutube(user?.socialNetworks?.youtube)
        setValue(user?.socialNetworks?.value)
        // setLogoFile(URL.createObjectURL(user?.avatar))
    }, [user])

    React.useEffect(() => {
        if (email) {
            const isEmailValid = regex.emailPattern.test(email)
            setEmailError(isEmailValid)
        }
    }, [email])

    React.useEffect(() => {
        if (mobileNumber) {
            const isMobileValid = regex.numberPattern.test(mobileNumber)
            setMobileError(isMobileValid)
        }
    }, [mobileNumber])

    React.useEffect(() => {
        if (gstNumber) {
            const isGstValid = regex.gstPattern.test(gstNumber)
            setGstError(isGstValid)
        }
    }, [gstNumber])

    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("user")) {
            navigate('/')
        }
    }, [])

    const handleCompanyLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            let formData = new FormData();
            formData.append("image", file);
            dispatch(uploadImages(formData,(data) => {
                console.log(data)
            }))
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        setLogoFile(file);
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);


            // if (window.isImageValid) {
            //     setLogoFile(file);
            // }else{
            //     setLogoFile("");
            // }
        }
    }

    const handleSubmit = () => {
        setLoading(true);
        console.log(logoFile,fullName,mobileNumber,establishedYear,industry,type,country
           ,state,city,gstNumber,gstFile);
        if (!logoFile || !fullName || !mobileNumber || !establishedYear || !industry || !type || !country
            || !state || !city || !gstNumber || !gstFile) {
            enqueueSnackbar("Please add all the required fields", { variant: 'warning' });
            setLoading(false);
        } else {
            let payload = {
                avatar: URL.createObjectURL(logoFile),
                shortNameOfCompany: shortName,
                fullnameOfCompany: fullName,
                number: mobileNumber,
                directOfficeNumber: directOfficeNumber,
                website: website,
                establishedIn: establishedYear,
                teamSize: teamSize,
                industry: industry,
                ownershipType: type,
                country: country?.name,
                state,
                city,
                pinCode,
                address,
                description: value,
                GST_Number: gstNumber,
                taxIdentificationNumber,
                socialNetworks: {
                    linkedIn: linkedin,
                    twitter,
                    instagram,
                    facebook,
                    whatsApp,
                    youtube
                },
                isProfileCompleted: true
            }
            let role = JSON.parse(localStorage.getItem("user"));
            dispatch(createProfile(payload, role._id, role.role, (data) => {
                console.log(data)
                enqueueSnackbar(data.data.message, { variant: 'success' });
                setLoading(false);
                navigate('/employer/dashboard');
            }, (err) => {
                setLoading(false);
                enqueueSnackbar("Error Occured! please try again", { variant: 'error' });
            }, localStorage.getItem("refreshToken")))
        }
    }


    return (
        <>
            <Layout>

                <Box mt={12}>
                    <Typography variant="h4" sx={{ fontWeight: '700', fontSize: "42px", textAlign: 'center' }}>Create Profile</Typography>
                    <Paper sx={{ mx: { md: 12, xs: 0 }, my: 6, py: 6, backgroundColor: "#F6F8F9" }} elevation={2}>
                        <Paper sx={{ mx: { md: 10, xs: 1 } }} elevation={2}>
                            <Box px={5} py={3}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Company Details</Typography>
                                <Divider sx={{ backgroundColor: '#d2d2d2', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                            </Box>

                            <Box px={5} py={3}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6} md={2} >
                                        <Box py={3} sx={{ backgroundColor: 'rgba(210, 210, 210, 0.6)', textAlign: 'center', borderRadius: '10px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                            {
                                                logoFile != ""
                                                    ?
                                                    <img
                                                        src={URL.createObjectURL(logoFile)}
                                                        style={{ width: '100px', height: '100px', objectFit: 'contain', textTransform: 'none' }}
                                                    />
                                                    :
                                                    <PersonIcon sx={{ color: '#fff', fontSize: '6rem', color: '#2544EE' }} />

                                            }
                                            <Button
                                                variant="contained"
                                                component="label"
                                                my={3}
                                                sx={{ width: '90%', height: '20%', fontSize: "8px", fontWeight: '200', backgroundColor: '#2544EE', textTransform: 'none' }}
                                            >
                                                Upload Company Logo
                                                <input
                                                    onChange={handleCompanyLogoUpload}
                                                    type="file"
                                                    accept=".jpg,.png"
                                                    hidden
                                                    required
                                                />
                                            </Button>
                                        </Box>
                                        {/* <FormControlLabel control={<Checkbox defaultChecked />}
                                    label={
                                        <Typography variant="body2" sx={{ fontSize: '8px' }}>is Prim.</Typography>
                                    } /> */}
                                    </Grid>

                                    <Grid item xs={6} md={10}>
                                        <p style={{ fontWeight: 600 }}>Profile Image :- Max file size is 1MB, Minimum dimension: 136 x 136 And Suitable files are .jpg & .png</p>
                                    </Grid>
                                </Grid>

                                <Box sx={{ my: 4 }}>
                                    <Grid container >
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Short Name of Company" topSpace={true}>
                                                <input
                                                    value={shortName}
                                                    type="text"
                                                    placeholder="Enter Short name of Company like TCS, ITC, etc"
                                                    onChange={(e) => setShortName(e.target.value)}
                                                />
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Company Full Name*" topSpace={true}>
                                                <input
                                                    disabled
                                                    required
                                                    value={fullName}
                                                    type="text"
                                                    placeholder="Enter your company full name"
                                                    onChange={(e) => setFullName(e.target.value)}
                                                />
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Email Address*" topSpace={true}>
                                                <input type="text"
                                                    required
                                                    disabled
                                                    placeholder="Enter your email address"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </InputStyle>
                                            {!emailError ?
                                                <p className="input-heading" style={{ color: 'red' }}>Invalid input</p>
                                                : ""}
                                        </Grid>
                                    </Grid>

                                    <Grid container my={2}>
                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                component="label"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "Inter",
                                                    fontSize: 14,
                                                }}
                                            >
                                                Mobile Number*
                                            </Typography>
                                            <NumberInput isdisabled={true} setCountryCode={setCountryCode} mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                component="label"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "Inter",
                                                    fontSize: 14,
                                                }}
                                            >
                                                Direct Office Number
                                            </Typography>
                                            <NumberInput setCountryCode={setCountryCode} mobileNumber={directOfficeNumber} setMobileNumber={setDirectOfficeNumber} />
                                        </Grid>
                                        {/* <Grid item md={4}>
                                    <Typography
                                        component="label"
                                        sx={{
                                            fontWeight: 500,
                                            fontFamily: "Inter",
                                            fontSize: 12,
                                        }}
                                    >
                                        Direct Office Number
                                    </Typography>
                                    <Grid container>
                                        <Grid item md={4}>
                                            <Box className="input-box mb-3">
                                                <div className="icon">
                                                    <img src={flagIcon} alt="icon" />
                                                </div>
                                                <input
                                                    value={directOfficeNumber}
                                                    onChange={(e) => setDirectOfficeNumber(e.target.value)}
                                                    placeholder="City Code"
                                                    require
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item md={8}>

                                            <input type="text"
                                                className="input-box mb-3"
                                                placeholder="Office Number"
                                                value={directOfficeNumber}
                                                onChange={(e) => setDirectOfficeNumber(e.target.value)}
                                            />


                                        </Grid>
                                    </Grid>

                                </Grid> */}
                                        <Grid item xs={12} md={4}>
                                            <Typography
                                                component="label"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "Inter",
                                                    fontSize: 14,
                                                }}
                                            >
                                                Office Number : EPABX
                                            </Typography>
                                            <NumberInput setCountryCode={setCountryCode} mobileNumber={officeNumber} setMobileNumber={setOfficeNumber} />

                                        </Grid>
                                    </Grid>

                                    <Grid container my={2}>
                                        <Grid item xs={12} md={4} >
                                            <InputStyle name="Website" topSpace={true}>
                                                <input
                                                    type="text"
                                                    placeholder="Website"
                                                    value={website}
                                                    onChange={(e) => setWebsite(e.target.value)}
                                                />
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Established In*" topSpace={true}>

                                                <select className="input-box" type="text" placeholder="Select" list="companyList"
                                                    required
                                                    value={establishedYear}
                                                    onChange={(e) => setEstablishedYear(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {last30Years.map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </select>
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Team Size " topSpace={true}>
                                                <select className="input-box" type="text" placeholder="Select Team Size"
                                                    list="companyList"
                                                    value={teamSize}
                                                    onChange={(e) => setTeamSize(e.target.value)}>
                                                    <option value="">Select team Size</option>
                                                    <option value="10-15">10-15</option>
                                                    <option value="20-30">20-30</option>
                                                    <option value="30-50">30-50</option>
                                                    <option value="50+">50+</option>
                                                </select>
                                            </InputStyle>
                                        </Grid>
                                    </Grid>

                                    <Grid container my={2}>
                                        <Grid item xs={12} md={4} >
                                            <InputStyle name="Industry*" topSpace={true}>
                                                <select className="input-box" type="text"

                                                    placeholder="Select"

                                                    list="companyList"
                                                    value={industry}
                                                    onChange={(e) => setIndustry(e.target.value)} >
                                                    <option value="">Select</option>
                                                    <option value="Information Technology">Information Technology (IT)</option>
                                                    <option value="Finance and Banking">Finance and Banking</option>
                                                    <option value="Healthcare and Medical">Healthcare and Medical</option>
                                                    <option value="Education and Training">Education and Training</option>
                                                    <option value="Sales and Marketing">Sales and Marketing</option>
                                                    <option value="Manufacturing and Production">Manufacturing and Production</option>
                                                    <option value="Retail and E-commerce">Retail and E-commerce</option>
                                                    <option value="Hospitality and Tourism">Hospitality and Tourism</option>
                                                    <option value="Telecommunications">Telecommunications</option>
                                                    <option value="Consulting and Professional Services">Consulting and Professional Services</option>
                                                    <option value="Engineering and Construction">Engineering and Construction</option>
                                                    <option value="Automotive and Transportation">Automotive and Transportation</option>
                                                    <option value="Energy and Utilities">Energy and Utilities</option>
                                                    <option value="Media and Entertainment">Media and Entertainment</option>
                                                    <option value="Nonprofit and Social Services">Nonprofit and Social Services</option>
                                                    <option value="Government and Public Administration">Government and Public Administration</option>
                                                    <option value="Insurance">Insurance</option>
                                                    <option value="Real Estate">Real Estate</option>
                                                    <option value="Agriculture and Farming">Agriculture and Farming</option>
                                                    <option value="Food and Beverage">Food and Beverage</option>
                                                    <option value="Fashion and Apparel">Fashion and Apparel</option>
                                                    <option value="Sports and Recreation">Sports and Recreation</option>
                                                    <option value="Art and Design">Art and Design</option>
                                                    <option value="Pharmaceuticals">Pharmaceuticals</option>
                                                    <option value="Environmental and Sustainability">Environmental and Sustainability</option>
                                                    <option value="Logistics and Supply Chain">Logistics and Supply Chain</option>
                                                    <option value="Human Resources and Recruitment">Human Resources and Recruitment</option>
                                                    <option value="Legal Services">Legal Services</option>
                                                    <option value="Research and Development">Research and Development</option>
                                                    <option value="Gaming and Software Development">Gaming and Software Development</option>
                                                </select>
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Ownership Type*" topSpace={true}>

                                                <select className="input-box" placeholder="Select" list="companyList"
                                                    value={type}
                                                    onChange={(e) => setType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="Individual Ownership">Individual Ownership</option>
                                                    <option value="Partnership">Partnership</option>
                                                    <option value="Corporation">Corporation</option>
                                                    <option value="Joint Venture">Joint Venture</option>
                                                    <option value="Nonprofit or Government Ownership">Nonprofit or Government Ownership</option>
                                                </select>
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Country* " topSpace={true}>
                                                {/* <input type="text" placeholder="Enter Your Country" list="companyList"
                                                    value={country}
                                                    onChange={(e) => setCountry(e.target.value)} /> */}
                                                <select
                                                    className="input-box"
                                                    type="text"
                                                    placeholder="Select Country"
                                                    list="countryList"
                                                    value={country?.isoCode}
                                                    onChange={handleChangeCountry}
                                                >
                                                    <option value="">Select</option>
                                                    {allCountryList.map((item, index) => (
                                                        <option key={index} value={item.isoCode}>{item.name}</option>
                                                    ))}
                                                </select>
                                            </InputStyle>
                                        </Grid>
                                    </Grid>

                                    <Grid container my={2}>
                                        <Grid item xs={12} md={4} >
                                            <InputStyle name="State*" topSpace={true}>
                                                {/* <input type="text" placeholder="Enter Your State"
                                                    value={state}
                                                    onChange={(e) => setState(e.target.value)} /> */}
                                                <select
                                                    className="input-box"
                                                    type="text"
                                                    placeholder="Select State"
                                                    list="stateList"
                                                    defaultValue={"selectCity"}
                                                    disabled={country == "" || country == undefined}

                                                    id="selectState"
                                                    onChange={handleChangeState}

                                                >
                                                    <option>Select</option>
                                                    {allStates.map((item, index) => (
                                                        <option key={index} value={item.isoCode}>{item.name}</option>
                                                    ))}
                                                </select>

                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="City" topSpace={true}>
                                                {/* <input
                                                    value={city}
                                                    onChange={(e) => setCity(e.target.value)}
                                                    placeholder="Enter your city"
                                                    require
                                                /> */}
                                                <select
                                                    className="input-box"
                                                    type="text"
                                                    placeholder="Select City"
                                                    list="cityList"
                                                    disabled={state == "" || state == undefined}
                                                    id="selectCity"
                                                    onChange={handleChangeCity}
                                                >
                                                    <option value="">Select</option>
                                                    {allCities.map((item, index) => (
                                                        <option key={index} value={item.name} > {item.name}</option>
                                                    ))}
                                                </select>
                                            </InputStyle>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <InputStyle name="Pincode " topSpace={true}>
                                                <input type="number" placeholder="Enter Your Pincode"
                                                    value={pinCode}
                                                    onChange={(e) => setPinCode(e.target.value)} />
                                            </InputStyle>
                                        </Grid>


                                    </Grid>

                                    <Grid container my={2}>
                                        <Grid item md={12}>
                                            <Typography
                                                component="label"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "Inter",
                                                    fontSize: 14,
                                                }}
                                            >
                                                Address
                                            </Typography>
                                            <textarea
                                                style={{ width: '100%', resize: 'none', border: '1.07838px solid #E0E4EC', borderRadius: '5px', color: '#8D98AA', padding: '1rem' }}
                                                placeholder="Enter Your Address"
                                                value={address}
                                                rows="4" cols="50"
                                                onChange={(e) => setAddress(e.target.value)}

                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container my={2}>
                                        <Grid item md={12}>
                                            <Typography
                                                component="label"
                                                sx={{
                                                    fontWeight: 600,
                                                    fontFamily: "Inter",
                                                    fontSize: 14,
                                                }}
                                            >
                                                Description
                                            </Typography>
                                            <JoditEditor
                                                ref={editor}
                                                onChange={(newContent) => setValue(newContent)}
                                                value={value}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>
                        </Paper>

                        <Paper sx={{ mx: { md: 10, xs: 1 }, my: 3, py: 3 }} elevation={2}>
                            <Box px={5} py={3}>
                                <Typography variant="h6" sx={{ fontWeight: '700' }}> Document</Typography>
                                <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                            </Box>

                            <Grid container sx={{ px: 5 }}>
                                <Grid item xs={12} md={8}>
                                    <InputStyle name="GST Number* " topSpace={true} >
                                        <input
                                            type="text"
                                            placeholder="Enter Your GST Number"
                                            value={gstNumber}
                                            onChange={(e) => setGstNumber(e.target.value)} />
                                    </InputStyle>
                                    {!gstError ?
                                        <p className="input-heading" style={{ color: 'red' }}>Invalid input</p>
                                        : ""}
                                </Grid>

                                <Grid item xs={12} md={4} py={3}>
                                    <InputStyle name=" " topSpace={true} >
                                        <Button
                                            variant="outlined"
                                            component="label"
                                            sx={{
                                                width: '100%',
                                                height: '3rem',
                                                fontSize: '14px',
                                                borderRadius: '4px',
                                                padding: '6px 12px',
                                                // backgroundColor: '#F8FAFF',
                                                border: '1px solid #E5E5E5',
                                                color: '#2544EE',
                                                textTransform: 'none'
                                            }}
                                        >
                                            {gstFile
                                                ?
                                                <p>{gstFile.name}</p>
                                                :
                                                <>
                                                    <CloudUploadIcon sx={{ mx: 5 }} />
                                                    <p style={{ color: '#000', opacity: '0.5', margin: '0px' }}>Upload Document</p>
                                                    <input type="file" hidden
                                                        accept="image/png, image/gif, image/jpeg"
                                                        value={gstFile}
                                                        onChange={(e) => setGstFile(e.target.files[0])} />
                                                </>}

                                        </Button>
                                    </InputStyle>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ px: 5, }}>
                                <Grid item xs={12} md={8}>
                                    <InputStyle name="Tax Identification Number" topSpace={true} >
                                        <input type="text" placeholder="Enter Your Tax Identification Number"
                                            value={taxIdentificationNumber}
                                            onChange={(e) => setTaxIdentificationNumber(e.target.value)} />
                                    </InputStyle>
                                </Grid>

                                <Grid item xs={12} md={4} py={3}>
                                    <InputStyle name="" topSpace={true} >

                                        <Button
                                            variant="outlined"
                                            component="label"
                                            sx={{
                                                width: '100%',
                                                height: '3rem',
                                                fontSize: '14px',
                                                borderRadius: '4px',
                                                padding: '6px 12px',
                                                // backgroundColor: '#F8FAFF',
                                                border: '1px solid #E5E5E5',
                                                color: '#2544EE',
                                                textTransform: 'none'
                                            }}
                                        >
                                            {taxFile
                                                ?
                                                <p>{taxFile.name}</p>
                                                :
                                                <>
                                                    <CloudUploadIcon sx={{ mx: 5 }} />
                                                    <p style={{ color: '#000', opacity: '0.5', margin: '0px' }}>Upload Document</p>
                                                    <input type="file" hidden
                                                        accept="image/png, image/gif, image/jpeg"
                                                        value={taxFile}
                                                        onChange={(e) => setTaxFile(e.target.files[0])} />
                                                </>}
                                        </Button>
                                    </InputStyle>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper sx={{ mx: { md: 10, xs: 1 }, my: 3, py: 2 }} elevation={2}>
                            <Box px={5} py={3}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}> Social Network</Typography>
                                <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                            </Box>

                            <Grid container sx={{ px: 5 }}>
                                <Grid item xs={12} md={4}>
                                    <InputStyle name="Linkedin" topSpace={true} >
                                        <input type="text" placeholder="Enter your linkedin"
                                            value={linkedin}
                                            onChange={(e) => setLinkedin(e.target.value)} />
                                    </InputStyle>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <InputStyle name="Twitter" topSpace={true} >
                                        <input type="text" placeholder="Enter your twitter"
                                            value={twitter}
                                            onChange={(e) => setTwitter(e.target.value)} />
                                    </InputStyle>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <InputStyle name="Instagram" topSpace={true} >
                                        <input type="text" placeholder="Enter your instagram"
                                            value={instagram}
                                            onChange={(e) => setInstagram(e.target.value)} />
                                    </InputStyle>
                                </Grid>
                            </Grid>
                            <Grid container sx={{ px: 5 }}>
                                <Grid item xs={12} md={4}>
                                    <InputStyle name="Facebook" topSpace={true} >
                                        <input type="text" placeholder="Enter your facebook"
                                            value={facebook}
                                            onChange={(e) => setFacebook(e.target.value)} />
                                    </InputStyle>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <InputStyle name="Whatsapp" topSpace={true} >
                                        <input type="text" placeholder="Enter your whatsapp"
                                            value={whatsApp}
                                            onChange={(e) => setWhatsApp(e.target.value)} />
                                    </InputStyle>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <InputStyle name="Youtube " topSpace={true} >
                                        <input type="text" placeholder="Enter your youtube"
                                            value={youtube}
                                            onChange={(e) => setYoutube(e.target.value)} />
                                    </InputStyle>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper sx={{ mx: { md: 10, xs: 1 }, my: 3, py: 2 }} elevation={2}>
                            <Box px={5} >
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}> Work Pictures & Videos</Typography>
                                <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                            </Box>

                            <Grid container mx={4} py={2} >
                                {
                                    pictures && pictures.length > 0
                                        ?
                                        pictures.map((item, index) => (
                                            <Grid item md={2}>
                                                {
                                                    item.name.includes("png") || item.name.includes("jpg")
                                                        ?
                                                        <img
                                                            style={{ width: '100%', height: '100%', margin: '1rem 1rem', objectFit: 'cover' }}
                                                            src={URL.createObjectURL(item)}
                                                        />
                                                        :
                                                        <video src={URL.createObjectURL(item)} autoPlay />
                                                }
                                            </Grid>
                                        ))
                                        :
                                        ""

                                }
                                <Grid item md={2} py={3} sx={{ marginLeft: '1rem' }}>
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            fontSize: '14px',
                                            borderRadius: '4px',
                                            padding: '6px 12px',
                                            backgroundColor: '#F8FAFF',
                                            border: '1px solid #E5E5E5',
                                            color: '#000',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            opacity: '0.5'
                                        }}
                                    >
                                        <CloudUploadIcon sx={{ fontSize: '6rem', }} />
                                        <Typography>Upload File</Typography>
                                        <input type="file" hidden
                                            accept=".jpg,.png,.mp4"
                                            onChange={(e) => {
                                                if (e.target.files[0].name.includes("jpg") || e.target.files[0].name.includes("png") || e.target.files[0].name.includes("mp4")) {
                                                    setPictures(oldArr => [...oldArr, e.target.files[0]])
                                                } else {
                                                    enqueueSnackbar("please upload a file with mp4,jpg or png format", { variant: 'warning' });
                                                }
                                            }} />
                                    </Button>
                                </Grid>

                            </Grid>
                        </Paper>

                        <Button mx={10} sx={{
                            mx: 10,
                            backgroundColor: '#2544EE',
                            borderRadius: '2rem',
                            px: 10,
                            py: 2,
                            '&:hover': {
                                backgroundColor: '#FFF',
                                color: '#2544EE',
                            },
                            textTransform: 'none',
                            fontSize: 16
                        }}
                            disabled={loading}
                            onClick={handleSubmit}
                            variant="contained">
                            {
                                loading
                                    ?
                                    <CircularProgress size={24} />
                                    :
                                    "Create"
                            }
                        </Button>
                    </Paper>
                </Box >
            </Layout>
        </>
    );
}

export default Profile;
